import { Radio as ArcoRadio } from '@arco-design/web-react';
import Group from './group';
import _Radio from './radio';
var GroupContext = ArcoRadio.GroupContext;
var Radio = _Radio;
Radio.__BYTE_RADIO = true;
Radio.Group = Group;
Radio.GroupContext = GroupContext;
export * from './interface';
export default Radio;
